// import chapter from './apis/chapter'
// import detailctx from './apis/detailctx'
import brief from './apis/brief';
import node from './apis/node';
import leaf from './apis/leaf';
import user from './apis/user';
import prodid from './apis/prodid';
const common = {
    brief, node, leaf, user, prodid
};
export default common;
